import * as types from './types';

export const setSaving = payload => ({
  type: types.SET_SAVING,
  payload,
});

